import * as React from 'react';

import { green, grey } from '@mui/material/colors';
import SwipeableDrawer from '@mui/material/SwipeableDrawer';
import { drawerWidth } from '../PersistentDrawerLeft';
import { Avatar, Box, Button, Divider } from '@mui/material';
import { titleCase } from '../../utils/utils';
import { UserContext } from '../../contexts/userContext';
import UserProfileEdition from '../UserProfileEdition';
import { Logout, ManageAccounts } from '@mui/icons-material';

const drawerBleeding = 0;

export default function UserProfile() {
  const [open, setOpen] = React.useState(false);
  const [openUserEdition, setOpenUserEdition] = React.useState(false);
  const { user, setLogout } = React.useContext(UserContext);
  if (!user?.firstName || !user?.lastName) return null;

  const userAvatar = (
    <>
      <Avatar sx={{ bgcolor: green[500], marginRight: '8px' }}>
        {`${user.firstName[0].toLocaleUpperCase()}${user.lastName[0].toLocaleUpperCase()}`}
      </Avatar>
      {titleCase(`${user?.firstName} ${user?.lastName}`)}
    </>
  );

  return (
    <>
      <UserProfileEdition onClose={() => setOpenUserEdition(false)} open={openUserEdition} />
      <div
        id="AvatarDiv"
        style={{ cursor: 'pointer', display: 'contents' }}
        onClick={() => setOpen(true)}
      >
        {userAvatar}
      </div>
      <SwipeableDrawer
        id="SwipeableDrawer"
        anchor="top"
        open={open}
        onClose={() => setOpen(false)}
        onOpen={() => setOpen(true)}
        swipeAreaWidth={drawerBleeding}
        disableSwipeToOpen={false}
        ModalProps={{
          keepMounted: true,
        }}
        sx={{
          width: drawerWidth,
          flexShrink: 0,
          '& .MuiDrawer-paper': {
            width: drawerWidth,
            boxSizing: 'border-box',
          },
        }}
      >
        <Box
          id="StyledBoxA"
          sx={{
            position: 'absolute',
            top: -drawerBleeding,
            borderTopLeftRadius: 8,
            borderTopRightRadius: 8,
            visibility: 'visible',
            right: 0,
            left: 0,
            cursor: 'pointer',
            display: 'contents',
          }}
          style={{ cursor: 'pointer', display: 'contents' }}
        >
        </Box>
        <Box
          sx={{
            px: 2,
            pb: 2,
            height: '100%',
            overflow: 'auto',
            padding: 1,
          }}
        >
          <div
            style={{ marginBottom: 16, cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
            onClick={() => setOpen(false)}
          >
            {userAvatar}
          </div>
          <Divider />
          <div style={{ padding: 8 }}>
            <Button
              fullWidth
              style={{ justifyContent: 'flex-start', color: grey[700] }}
              variant='text'
              startIcon={<Logout />}
              onClick={() => {
                localStorage.setItem('userProfile', '{}');
                setLogout(true);
                setOpen(false);
              }}
            >
               Salir
            </Button>
            <Divider />
            <Button
              fullWidth
              style={{ justifyContent: 'flex-start', color: grey[700] }}
              variant='text'
              startIcon={<ManageAccounts />}
              onClick={() => {
                localStorage.setItem('userProfile', '{}');
                setOpen(false);
                setOpenUserEdition(true);
              }}
            >
               Usuario/contraseña
            </Button>
          </div>
        </Box>
      </SwipeableDrawer>
    </>
  );
}
